/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import injectReducer from '../../../utils/injectReducer';
import injectSaga from '../../../utils/injectSaga';
import * as cartActions from '../../../services/Cart/actions';
import saga from '../../../services/Cart/sagas';
import cartDetails from '../../../services/Cart/reducer';
import { getPlansData } from '../../../utils/plansReference';
import mCartDueMonthly from '../../../components/MiniCart/redesign/mCartDueMonthly';

export const mapStateToProps = (state) => {
  const cartData = state.cartDetails || {};
  const dueMonthlyList = state.cartDetails ? state.cartDetails.cartDetailsJson.dueMonthlyList : {};
  const dueMonthlyTaxes = state.cartDetails ? state.cartDetails.cartDetailsJson.dueMonthlyTaxes : {};
  const dueMontAmount = state.cartDetails ? state.cartDetails.cartDetailsJson.orderDetailsView : {};
  const plansReferenceData = getPlansData(state.plansReferenceData);
  const selectedPlan = state.cBandPlans?.planSelected || {};
  const cBandPlans = state.cBandPlans?.plans?.output?.plans || {};
  const progressivePlanDetails = state?.progressivePlans || {};
  return {
    cartData,
    isCartVisible: cartData.isCartVisible,
    dueMonthlyList,
    dueMonthlyTaxes,
    dueMontAmount,
    selectedPlan,
    cBandPlans,
    plansReferenceData,
    progressivePlanDetails,
  };
};
export function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...cartActions }, dispatch);
}
const withReducer = compose(injectReducer({ key: 'cartDetails', reducer: cartDetails }));
const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withSaga = injectSaga({ key: 'cartDetails', saga });
export default withRouter(compose(withSaga, withReducer, withConnect)(mCartDueMonthly));
